export const TIME_FRAME_MAP = {
  FixedHour: {
    id: 'fixedHour',
    title: 'Fixed Hour'
  },
  TimeRange: {
    id: 'timeRange',
    title: 'Time Range'
  }
};
